import { render, staticRenderFns } from "./EmployeeTrainingHistoryModal.vue?vue&type=template&id=01bd3949&"
import script from "./EmployeeTrainingHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTrainingHistoryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports